import React, { Component } from 'react';
import "../../../assets/scss/style/_header.scss";
import http from "../../services/HttpService";
import TextField from '@material-ui/core/TextField';
import { Link } from "react-router-dom";
import Route from "../../Routes";
import { AUTH_LOGIN } from "../../store/actions";
import PropTypes from "prop-types";
import { connect } from "react-redux";
@(connect((state: any) => {
    return {
        isLogged: state.AuthReducer.isLogged,
        user: state.AuthReducer.user,
    };
}) as any)
class Header extends Component<any> {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };
    state = {
        popUp: false,
        popUpName: "",
        forgotPass: null,
        industries: [],
        industry_value: null,
        selectedIndustry: null,
        specializations: [],
        selectedSpec: [],
        specialization_value: null,
        loginError: "",
        error: {
            name: null,
            surname: null,
            email: null,
            password: null,
        },
        name: null,
        surname: null,
        email: "",
        password: "",
    }
    constructor(props: Map<any, any>) {
        super(props);
    }
    componentDidMount = () => {
        this.getIndustry()
    }
    validTestAndSave = (event) => {
        const id = event.target.id
        
        let value = event.target.value;
        if (id == "name") {
            let err = this.state.error;
            err.name = "Please input name";
            if (value.length < 1) {
                this.setState({ error: err });
                return
            }
            err.name = true
            this.setState({ name: event.target.value });
            return
        }
        if (id == "surname") {
            let err = this.state.error;
            if (value.length < 1) {
                err.surname = "Please input surname";
                if (value.length < 1) {
                    this.setState({ error: err });
                    return
                }
            }
            err.surname = true
            this.setState({ surname: event.target.value });
            
            return
        }
        if (id == "email") {
            let err = this.state.error;
            err.email = "Please input valid Email";
            if (
                /^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/.test(
                    event.target.value
                ) == false
            ) {


                this.setState({ error: err });
                return
            }
            err.email = true
            this.setState({ email: event.target.value });

            return
        }

        if (id == "password") {
            let err = this.state.error;
            err.password = "Please input valid Password";
            if (
                /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(
                    event.target.value
                ) == false
            ) {


                this.setState({ error: err });
                return
            }
            err.password = true
            this.setState({ password: event.target.value });
            
            return
        }


    };

    getIndustry() {
        http.get(`/industries/all`)
            .then(response => response.json())
            .then((data) => {
                this.setState({
                    industries: data,
                }
                );
               
            });

    }


    handleChangeIndustry = (e) => {
        this.setState({ selectedSpec: [] })

        const id = e.target.value
        const k = Number(e.target.id)
        
        const industry_value = this.state.industries[e.target.value]
      
        industry_value !== null ?
            http.get(`/industries/getById/${industry_value._id}`)
                .then(response => response.json())
                .then((data) => {
                    let a = { key: k, id: industry_value._id, name: industry_value.i_name.replace(/\//g, "-") }
                    this.setState({
                        specializations: data.specializations,
                        industry_value: a,
                        specialization_value: null,
                        selectedIndustry: id
                    });

                })
            : this.setState({
                industry_value: null,
                specializations: [],
                specialization_value: null,
            });
    }


    popUpOpen = (e) => {
        this.setState({ popUp: true, popUpName: e.target.id, forgotPass: null })


    }
    popUpClose = (e) => {
        if (e.target.id == "shadow") this.setState({ popUp: false })


    }



    formSubmitSignIn = (event) => {
        event.preventDefault();

        this.setState({ submitted: true });
        this.setState({ loading: true });

        const { email, password } = this.state;


        const postData = {
            email: email,
            password: password,
        };

        http.post("/users/login", postData)
            .then((response: Response) => {
                if (response.ok) {
                    response.json().then((data: any) => {
                        if (data.status == 'success') {
                            this.props.dispatch({
                                type: AUTH_LOGIN,
                                payload: data,
                            });
                            this.setState({ popUp: false })
                           
                            this.setState({
                                loginError: "",

                            });
                        } else {
                            if (data.verifyError) {
                                this.setState({
                                    loginError: "Invalid email or password",
                                    newErrVerify: data.verifyError,
                                    loading: false
                                });

                            } else {
                                this.setState({
                                    loginError: "Invalid email or password",
                                    loading: false
                                });
                            }
                        }
                    });
                } else {
                    response.json().then((jsonData: any) => {
                        this.setState({
                            errors: jsonData.errors,
                        });
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }


    formSubmitSignUp = (event) => {
        event.preventDefault();

        this.setState({ submitted: true });
        this.setState({ loading: true });

        const { name, surname, email, password } = this.state;

        http.post('/users/register', {
            role: 'user',
            name: name,
            surname: surname,
            email: email,
            password: password,
        }).then((response: any) => {
           
            if (response.ok) {
                response.json().then((data: any) => {
                   
                    if (data.status == 'success') {

                        this.setState({
                            updated: false,
                            userMessage: true,
                            v_message: data.message
                        });
                    } else {
                        if (data.errorU) {
                            this.setState({
                                newErrVerify: data.errorU,
                                updated: false,
                                userMessage: false,
                            });
                        }
                    }
                });
            } else {
                response.json().then((jsonData: any) => {
                   
                    this.setState({
                        errors: jsonData.errors,
                    });
                });
            }
        })
            .catch((err) => {
                console.log(err, "error");
            });
    }

    specSelect = (elem, k) => {
        const list = this.state.selectedSpec
        const value = elem._id
        const label = elem.s_name
        const key = k
        const obj = {
            key,
            label,
            value
        }
        const idInArray = list.findIndex(item => item.key == key)
        if (
            idInArray == -1
        ) {
            list.push(obj)

            this.setState({ selectedSpec: list })


            return
        }
        list.splice(idInArray, 1)
        this.setState({ selectedSpec: list })
        return
    }

    render() {
        const { isLogged, user } = this.props;
        return (
            <div >
                <div className="header">
                    <Link to={Route.toUrl("home")}>
                        <img src="/Logo.png" ></img>
                    </Link>
                    {window.location.pathname == "/" || window.location.pathname == "/home" ? null:
                    <div className="searchBar">
                        <input placeholder="What kind of software are you looking for?" />
                        <button>Search</button>
                    </div>}
                 
                    <div className="buttGroup">
                        <button id="categories" onClick={e => this.popUpOpen(e)}>Categories</button>
                        {isLogged ? <div className="loginBlock"><button id="logOut" ><Link

                            to={Route.toUrl("account_logout")}>Logout
                                        </Link></button></div> : <div className="loginBlock">
                                <button id="logIn" onClick={e => this.popUpOpen(e)}>Log in</button>
                                <button id="signUp" onClick={e => this.popUpOpen(e)}>Sign up</button>
                            </div>}

                    </div>
                </div>
                <div className={this.state.popUp ? "popUp" : "hide"} onClick={(e) => {
                    this.popUpClose(e)
                }}>
                    <div className="shadow" id="shadow"></div>
                    <div className="popUpElements">
                        {this.state.popUpName == "categories" ? <div className="categoriesSelect"  >

                            <div className="categories">
                                <div>
                                    <h3>Categories</h3>
                                    <ul>
                                        {this.state.industries.map((item, index) => {
                                            return <li key={index} id={String(index)} className={this.state.selectedIndustry != null && Number(this.state.selectedIndustry) === index ? "selectedInd" : null} value={index} onClick={this.handleChangeIndustry.bind(index)}>{item.i_name}</li>
                                        })}


                                    </ul>
                                </div>
                                <button>All Categories</button>
                            </div>
                            <div className="specialization" >
                                <div>
                                    <h3>Specialization</h3>
                                    <div className="specList" id="#style-2">
                                        <ul>
                                            {this.state.specializations.map((elem, k) => {
                                                return <li key={k + 10} className={this.state.selectedSpec.findIndex(item => item.key == k) != -1 ? "selectedSpec" : null} onClick={e => this.specSelect(elem, k)} >{elem.s_name} </li>
                                            })}



                                        </ul>
                                    </div>
                                </div>


                                {this.state.industry_value ? <Link to={Route.toUrl("search", { query: JSON.stringify({ "industry_value": { "key": this.state.industry_value.key, "value": this.state.industry_value.id, "label": this.state.industry_value.name }, "specialization_value": this.state.selectedSpec, "keyword_value": "" }).replace(/\//g, "-") })}>
                                    <button className="learnMore">Search</button>
                                </Link> : null}

                            </div>

                        </div> : null}
                        {this.state.popUpName == "logIn" ?
                            <div className="logInPopUp"  >

                                <div className="firstSignUpBlock">
                                    <div className="firstSignUpBlock_content">
                                        <h3>Log In</h3>
                                        <p>
                                            Save your favorite products and vote for them to help others make a great decision.
                                    </p>
                                        <h4>Don't have an account  <span id="signUp" onClick={e => this.popUpOpen(e)}> Sign up </span></h4>
                                    </div>
                                </div>
                                <div className="secondSignUpBlock" >
                                    {this.state.forgotPass ? <div className="secondSignUpBlock_content">
                                        <h3>Find Your Account</h3>
                                        <div className="emailBlock">
                                            <TextField

                                                id="email"
                                                label="Email"


                                                onBlur={e => this.validTestAndSave(e)}

                                                fullWidth
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                variant="outlined"
                                            />
                                            <span className="errorSpan">{this.state.error.email ? this.state.error.email : null} </span>
                                        </div>



                                        <button onClick={this.formSubmitSignIn} >Next</button>
                                    </div>
                                        :
                                        <div className="secondSignUpBlock_content">
                                            <h3>Log in with Email</h3>
                                            <div className="emailBlock">
                                                <TextField

                                                    id="email"
                                                    label="Email"


                                                    onBlur={e => this.validTestAndSave(e)}

                                                    fullWidth
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    variant="outlined"
                                                />
                                                <span className="errorSpan">{this.state.error.email ? this.state.error.email : null} </span>
                                            </div>

                                            <div className="passBlock">
                                                <TextField
                                                    id="password"
                                                    label="Password"
                                                    onBlur={e => this.validTestAndSave(e)}
                                                    type="password"


                                                    fullWidth
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    variant="outlined"
                                                />
                                                <span onClick={() => this.setState({ forgotPass: true })}>Forget Your password?</span>
                                            </div>
                                            {this.state.loginError ? <span>{this.state.loginError}</span> : null}
                                            <button onClick={this.formSubmitSignIn} >Log in</button>
                                        </div>
                                    }


                                </div>

                            </div> : null}

                        {this.state.popUpName == "signUp" ?
                            <div className="logInPopUp"  >

                                <div className="firstSignUpBlock">
                                    <div className="firstSignUpBlock_content">
                                        <h3>Log In</h3>
                                        <p>
                                            Save your favorite products and vote for them to help others make a great decision.
                                    </p>
                                        <h4>Do you have an account ?    <span id="logIn" onClick={e => this.popUpOpen(e)}> Log in </span></h4>
                                    </div>
                                </div>
                                <div className="secondSignUpBlock" >
                                    <div className="secondSignUpBlock_content">
                                        <h3>Log in with Email</h3>
                                        <TextField
                                            id="name"
                                            label="Name"
                                            style={{ margin: 8 }}
                                            placeholder=""
                                            onBlur={e => this.validTestAndSave(e)}
                                            fullWidth
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            variant="outlined"
                                        />
                                        <TextField
                                            id="surname"
                                            label="Surname"
                                            style={{ margin: 8 }}
                                            placeholder=""
                                            onBlur={e => this.validTestAndSave(e)}
                                            fullWidth
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            variant="outlined"
                                        />
                                        <TextField
                                            id="email"
                                            label="Email"
                                            style={{ margin: 8 }}
                                            placeholder=""
                                            onBlur={e => this.validTestAndSave(e)}
                                            fullWidth
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            variant="outlined"
                                        />

                                        <TextField
                                            id="password"
                                            label="Password"
                                            onBlur={e => this.validTestAndSave(e)}
                                            type="password"


                                            fullWidth
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            variant="outlined"
                                        />

                                        <button onClick={this.formSubmitSignUp}>Log in</button>
                                    </div>
                                </div>


                            </div>

                            : null}



                    </div>

                </div>
            </div>
        );
    }
}

export default Header;
